<app-uni-dialog [parent]="this" [contentTemplate]="contentTemplate" [footerTemplate]="footerTemplate"></app-uni-dialog>

<ng-template #contentTemplate>
  <div *ngIf="isPageReady" class="flex flex-col h-full">
    <div class="qb-detail-card qb-primary-tint p-3 mb-3 shrink-0 text-sm">
      <div>
        Each product of style <b>{{ oldStyle.style }}</b> maps to one product of the feed style <b>{{ newStyle.style }}</b>.
        The system proposes the new product with the same choices. Make sure each line is correct. Then select Confirm.
      </div>
      <div class="mt-1" style="color: var(--p-text-muted-color, #6b7280)">
        {{ rows.length }} old products. {{ mappedCount }} have a new product. {{ confirmedCount }} are confirmed.
      </div>
      <div *ngIf="!isOldStyleLive" class="mt-1" style="color: var(--p-text-muted-color, #6b7280)">
        Style {{ oldStyle.style }} is {{ oldStyleStatusName }}.
      </div>
    </div>
    <div class="qb-child-actions shrink-0">
      <button pButton type="button" class="p-button-raised p-button-sm" icon="pi pi-check-square" (click)="confirmAllMapped()">
        <span>Confirm All Mapped</span>
      </button>
    </div>
    <app-ag-grid [gridOptions]="gridOptions" [rowData]="rows" class="flex-1 min-h-0"></app-ag-grid>
  </div>
</ng-template>

<ng-template #footerTemplate>
  <div class="flex flex-row gap-2">
    <button pButton type="button" class="p-button-raised" icon="pi pi-save" [disabled]="!isPageReady" (click)="save()">
      <span>Save</span>
    </button>
    <button
      *ngIf="isPageReady && isOldStyleLive"
      pButton
      type="button"
      class="p-button-raised"
      icon="pi pi-hourglass"
      [disabled]="!canPhaseout"
      [title]="canPhaseout ? '' : 'Confirm every old product that is not Inactive first.'"
      (click)="saveAndPhaseout()"
    >
      <span>Save and Put {{ oldStyle.style }} on Phaseout</span>
    </button>
    <button pButton type="button" class="p-button-raised p-button-secondary" (click)="cancel()">
      <span>Cancel</span>
    </button>
  </div>
</ng-template>
